(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-quantity"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalizeLineId = (value) => {
      if (value === null || value === undefined || value === '') return null;
      const normalized = String(value).trim();
      return normalized.length ? normalized : null;
    };

    const setLoadingState = (stepper, isLoading) => {
      if (!stepper) return;

      stepper.querySelectorAll('[data-cart-stepper-button]').forEach((button) => {
        const alreadyDisabled = button.disabled;

        button.classList.toggle('is-loading', isLoading && !alreadyDisabled);
        button.setAttribute('aria-busy', String(isLoading && !alreadyDisabled));
      });
    };

    const syncAllSteppers = () => {
      document.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
        syncStepperState(input);
      });
    };

    const syncStepperState = (input) => {
      const stepper = input?.closest('[data-cart-quantity]');
      if (!stepper) return;

      const buttons = stepper.querySelectorAll('[data-cart-stepper-button]');
      const note = stepper.parentElement?.querySelector('[data-cart-quantity-note]');
      const value = Number.parseInt(input.value, 10) || 0;
      const maxAttribute = input.getAttribute('data-max-quantity');
      const maxQuantity = maxAttribute !== null && maxAttribute !== '' ? Number.parseInt(maxAttribute, 10) : null;
      const limitReached = Number.isFinite(maxQuantity) && value >= maxQuantity;

      buttons.forEach((button) => {
        const direction = button.getAttribute('data-direction');
        const disabled = (direction === 'decrease' && value <= 0) || (direction === 'increase' && limitReached);

        button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));
        button.classList.toggle('is-loading', false);
        button.setAttribute('aria-busy', 'false');
      });

      if (note) {
        if (limitReached && Number.isFinite(maxQuantity)) {
          note.textContent = note.getAttribute('data-limit-message') || 'Max quantity';
          note.hidden = false;
        } else {
          note.hidden = true;
          note.textContent = '';
        }
      }
    };

    const emitQuantityChange = (input, quantity) => {
      if (!input || !document.body.contains(input)) return;

      const lineKey = input.getAttribute('data-line-key');
      const lineId = normalizeLineId(input.getAttribute('data-line-id') || lineKey);
      const cartRoot = input.closest('[data-cart-root]') || document.body;

      if (!lineId || !Number.isFinite(quantity) || quantity < 0) return;

      const detail = {
        lineKey,
        lineId,
        quantity,
      };

      console.log('[cart stepper] emitting quantity change', detail);

      cartRoot.dispatchEvent(
        new CustomEvent('cart:quantity-change', {
          bubbles: true,
          detail,
        })
      );
    };

    document.addEventListener('click', (event) => {
      const stepperButton = event.target.closest('[data-cart-stepper-button]');
      if (!stepperButton) return;

      const stepper = stepperButton.closest('[data-cart-quantity]');
      const input = stepper?.querySelector('[data-cart-quantity-input]');
      if (!input) return;

      const currentValue = Number.parseInt(input.value, 10) || 0;
      const direction = stepperButton.getAttribute('data-direction');
      const maxAttribute = input.getAttribute('data-max-quantity');
      const maxQuantity = maxAttribute !== null && maxAttribute !== '' ? Number.parseInt(maxAttribute, 10) : null;
      let nextValue = direction === 'increase' ? currentValue + 1 : Math.max(0, currentValue - 1);

      if (Number.isFinite(maxQuantity) && direction === 'increase') {
        nextValue = Math.min(nextValue, maxQuantity);
      }

      if (nextValue === currentValue) {
        console.log('[cart stepper] quantity capped at max available', {
          currentValue,
          maxQuantity,
          lineKey: input.getAttribute('data-line-key'),
          lineId: input.getAttribute('data-line-id'),
        });
        return;
      }

      console.log('[cart stepper] click before update', {
        direction,
        currentValue,
        nextValue,
        maxQuantity,
        lineKey: input.getAttribute('data-line-key'),
        lineId: input.getAttribute('data-line-id'),
      });

      setLoadingState(stepper, true);
      input.value = String(nextValue);
      emitQuantityChange(input, nextValue);
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;

      const quantity = Number.parseInt(input.value, 10);
      console.log('[cart stepper] change event', {
        value: input.value,
        quantity,
        lineKey: input.getAttribute('data-line-key'),
        lineId: input.getAttribute('data-line-id'),
      });
      syncStepperState(input);
      emitQuantityChange(input, quantity);
    });

    syncAllSteppers();

    document.addEventListener('cart:refresh', () => {
      document.querySelectorAll('[data-cart-quantity]').forEach((stepper) => setLoadingState(stepper, false));
      syncAllSteppers();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    const initializeContactSubjects = (container = document) => {
    container.querySelectorAll('.contact-form__subjects').forEach((subjects) => {
      if (subjects.dataset.initialized === 'true') return;

      const options = subjects.querySelectorAll('.contact-form__subject');

      const syncSelected = () => {
        options.forEach((option) => {
          const input = option.querySelector('.contact-form__subject-input');
          const label = option.querySelector('.contact-form__subject-label');
          label.classList.toggle('bulleted', input.checked);
        });
      };

      options.forEach((option) => {
        const input = option.querySelector('.contact-form__subject-input');
        const label = option.querySelector('.contact-form__subject-label');

        option.addEventListener('mouseenter', () => label.classList.add('bulleted'));
        option.addEventListener('mouseleave', () => label.classList.toggle('bulleted', input.checked));
        input.addEventListener('change', syncSelected);
      });

      subjects.dataset.initialized = 'true';
      syncSelected();
    });
  };

  initializeContactSubjects();
  document.addEventListener('shopify:section:load', (event) => initializeContactSubjects(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-initializer"] && !Shopify.designMode) return;
  try {
    window.initImagePlaceholders = (root = document) => {
    root.querySelectorAll('[data-image-placeholder]:not([data-image-initialized])').forEach((placeholder) => {
      placeholder.setAttribute('data-image-initialized', '');

      const image = placeholder.closest('.image');
      const finalImage = image?.querySelector('[data-image-final]');

      if (!finalImage) return;

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const width = Math.ceil(entry.contentRect.width);
            if (width > 0) finalImage.sizes = `${width}px`;
          });
        });

        resizeObserver.observe(image);
      }

      let hasRevealed = false;
      const revealFinalImage = async () => {
        if (hasRevealed) return;
        hasRevealed = true;

        try {
          await finalImage.decode();
        } catch {
          // The load event has completed, so continue when decode is unavailable or rejected.
        }

        await new Promise((resolve) => requestAnimationFrame(resolve));
        await new Promise((resolve) => requestAnimationFrame(resolve));

        finalImage.classList.add('is-ready');
        const completeReveal = () => {
          placeholder.remove();
          image.classList.add('is-ready');
        };

        finalImage.addEventListener('transitionend', completeReveal, { once: true });
        setTimeout(completeReveal, 650);
      };

      const loadFinalImage = () => {
        if (finalImage.dataset.imageLoading) return;
        finalImage.dataset.imageLoading = 'true';

        finalImage.addEventListener('load', revealFinalImage, { once: true });

        if (finalImage.dataset.srcset) finalImage.srcset = finalImage.dataset.srcset;
        if (finalImage.dataset.src) finalImage.src = finalImage.dataset.src;

        if (finalImage.complete && finalImage.naturalWidth > 0) {
          revealFinalImage();
        }
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries, currentObserver) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              currentObserver.disconnect();
              loadFinalImage();
            });
          },
          { threshold: 0.1 }
        );

        observer.observe(image);
      } else {
        loadFinalImage();
      }
    });
  };

  window.initImagePlaceholders();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lightbox"] && !Shopify.designMode) return;
  try {
    window.initLightboxes = (root = document) => {
    root.querySelectorAll('[data-lightbox-trigger]:not([data-lightbox-initialized])').forEach((trigger) => {
      trigger.setAttribute('data-lightbox-initialized', '');

      const lightbox = trigger.parentElement?.querySelector('[data-lightbox]');
      const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
      const closeButton = lightbox?.querySelector('[data-lightbox-close]');
      const previousButton = lightbox?.querySelector('[data-lightbox-previous]');
      const nextButton = lightbox?.querySelector('[data-lightbox-next]');

      if (!lightbox || !lightboxImage || !closeButton) return;

      const group = trigger.dataset.lightboxGroup;
      const groupedTriggers = group ? [...document.querySelectorAll(`[data-lightbox-group="${group}"]`)] : [trigger];
      const currentIndex = groupedTriggers.indexOf(trigger);

      const openTrigger = (nextTrigger) => {
        const nextLightbox = nextTrigger.parentElement?.querySelector('[data-lightbox]');
        const nextImage = nextLightbox?.querySelector('[data-lightbox-image]');

        if (!nextLightbox || !nextImage) return;

        lightbox.close();
        nextImage.classList.remove('is-ready');
        nextImage.addEventListener(
          'load',
          async () => {
            try {
              await nextImage.decode();
            } catch {
              // The image has loaded, so continue when decode is unavailable or rejected.
            }

            await new Promise((resolve) => requestAnimationFrame(resolve));
            await new Promise((resolve) => requestAnimationFrame(resolve));
            nextImage.classList.add('is-ready');
          },
          { once: true }
        );
        nextImage.src = nextTrigger.dataset.lightboxUrl;
        nextImage.alt = nextTrigger.dataset.lightboxAlt || '';
        nextLightbox.showModal();
        if (nextImage.complete && nextImage.naturalWidth > 0) {
          nextImage.dispatchEvent(new Event('load'));
        }
      };

      const revealImage = async () => {
        try {
          await lightboxImage.decode();
        } catch {
          // The image has loaded, so continue when decode is unavailable or rejected.
        }

        await new Promise((resolve) => requestAnimationFrame(resolve));
        await new Promise((resolve) => requestAnimationFrame(resolve));
        lightboxImage.classList.add('is-ready');
      };

      const loadImage = () => {
        lightboxImage.addEventListener('load', revealImage, { once: true });

        if (lightboxImage.complete && lightboxImage.naturalWidth > 0) {
          revealImage();
        }
      };

      trigger.addEventListener('click', () => {
        lightboxImage.classList.remove('is-ready');
        lightboxImage.src = trigger.dataset.lightboxUrl;
        lightboxImage.alt = trigger.dataset.lightboxAlt || '';
        lightbox.showModal();
        loadImage();
      });

      closeButton.addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });

      previousButton?.addEventListener('click', () => {
        if (currentIndex > 0) openTrigger(groupedTriggers[currentIndex - 1]);
      });

      nextButton?.addEventListener('click', () => {
        if (currentIndex < groupedTriggers.length - 1) openTrigger(groupedTriggers[currentIndex + 1]);
      });

      if (previousButton) previousButton.hidden = currentIndex <= 0;
      if (nextButton) nextButton.hidden = currentIndex >= groupedTriggers.length - 1;
    });
  };

  window.initLightboxes();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const body = document.body;
    const drawer = document.querySelector('[data-menu-root]');
    const opener = document.querySelector('[data-menu-open]');
    const closeTargets = document.querySelectorAll('[data-menu-close]');

    if (!drawer || !opener) return;

    let lastActiveElement = null;

    const setMenuState = (open) => {
      body.classList.toggle('menu-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      opener.setAttribute('aria-expanded', String(open));
      opener.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');

      if (open) {
        lastActiveElement = document.activeElement;
        drawer.focus();
      } else if (lastActiveElement) {
        lastActiveElement.focus();
      }
    };

    opener.addEventListener('click', () => setMenuState(true));
    closeTargets.forEach((target) => target.addEventListener('click', () => setMenuState(false)));

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenuState(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && body.classList.contains('menu-open')) {
        setMenuState(false);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
